'use strict';
require('./CompanyPublicationBlogService.js');
require('./EditPostDirective.js');
function CompanyPublicationBlogCtrl(
  $scope,
  $sce,
  $rootScope,
  $stateParams,
  $translate,
  $state,
  uploadTracker,
  CompanyPublicationBlogService,
  CompanyPublicationFileService,
  config,
  growl) {

  $scope.showFormNewPost = false;
  $scope.newPost = {
    title: '',
    content: ''
  };
  
  $rootScope.tinymceOptions.file_picker_types = 'image';

  $rootScope.tinymceOptions.file_picker_callback = function(callback, value, meta) {
    if (meta.filetype === 'image') {
      $('#upload').trigger('click');
      $('#upload').on('change', function() {
        var files = new Array(this.files);
        if(files && files.length > 0){
          uploadTracker(files.map(function(f) {
            return {
              url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/"+$stateParams.publicationId+"/files",
              file: f[0],
            };
          })).then(function(headers){
            var newId = headers[0].split('/').pop();
            var imageUrl = config.apiBase + '/files/' + newId;
            callback(imageUrl, {
              alt: ''
            });
          });
        }
      });
    }
  };

  $scope.updatePost = function(post) {
    if (!(!$scope.publication.uploadLock && $scope.currentUserPermissions.CompanyPublicationEdit)) {
      return;
    }
    CompanyPublicationBlogService.updatePost({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      postId: post.id
    }, post, function(){
      growl.addSuccessMessage($translate.instant('publication.save-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('publication.save-failure'));
    });
  };

  $scope.trustAsHtml = function(string) {
    return $sce.trustAsHtml(string);
  };
 
  $scope.publishPost = function() {
    CompanyPublicationBlogService.save({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId
    }, $scope.newPost, function(){
      growl.addSuccessMessage($translate.instant('publication.save-success'));
      $state.reload();
    }, function(){
      growl.addErrorMessage($translate.instant('publication.save-failure'));
    });
  };

  $scope.$on('files-uploaded', function(){
    CompanyPublicationFileService.query({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit:         1000
    }).$promise.then(function(files) {
      if (files.length > 0) {
        $scope.newPost.content = $scope.newPost.content + '\n' + '![]('+ config.apiBase + '/files/' + files[0].id +')';
      }
    });
  });
}

angular.module('dokiv')
  .controller('CompanyPublicationBlogCtrl', [
    '$scope',
    '$sce',
    '$rootScope',
    '$stateParams',
    '$translate',
    '$state',
    'UploadTracker',
    'CompanyPublicationBlogService',
    'CompanyPublicationFileService',
    'config',
    'growl',
    CompanyPublicationBlogCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/blogs/CompanyPublicationBlogCtrl.js
// module id = 394
// module chunks = 0